'use client';

import { useLocale } from 'next-intl';
import { Button } from '@/shared';

export default function LanguageSwitcher() {
  const locale = useLocale();
  const changeLanguage = () => {
    const newLocale = locale === 'en' ? 'ar' : 'en';
    window.location.href = `/${newLocale}`;
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        onClick={() => changeLanguage()}
        className="px-3 py-1.5 text-xs font-medium transition-colors">
        {locale === 'ar' ? 'EN' : 'ع'}
      </Button>
    </div>
  );
}
